import { render, staticRenderFns } from "./TodosInput.vue?vue&type=template&id=70629b08&"
import script from "./TodosInput.vue?vue&type=script&lang=js&"
export * from "./TodosInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports